import RoutesEnum from 'enums/routes.enum'
import LoadSessionMiddleware from 'middlewares/LoadSessionMiddleware'
import ForbidSubdomainMiddleware from 'middlewares/ForbidSubdomainMiddleware'

export default [
    {
        path: '/contact',
        name: RoutesEnum.CONTACT.CONTACT,
        view: 'contact/Contact',
        middlewares: [LoadSessionMiddleware, ForbidSubdomainMiddleware],
        meta: {
            layout: 'main',
            title: 'Kontakt | Bookeraj',
            description:
                'Kontaktirajte nas putem našeg kontakt formulara ili pronađite informacije za direktnu komunikaciju. Stojimo vam na raspolaganju za sva pitanja i podršku.',
        },
    },
]
